import { Component } from '@angular/core';

@Component({
  selector: 'app-trainings-and-diplomas',
  templateUrl: './trainings-and-diplomas.component.html',
  styleUrls: ['./trainings-and-diplomas.component.scss']
})
export class TrainingsAndDiplomasComponent {}
